import { css, CSSInterpolation } from '@emotion/css';
import React from 'react';
import { Indicator } from 'is24-corecss';
import { useIntl } from '@/i18n/hooks/useIntl';

const logo: CSSInterpolation = {
  fontWeight: '800 !important',
};

const styles = {
  logo,
  white: {
    color: '#ffffff !important',
  },
};

interface Props {
  variant: 'living' | 'search' | 'rent' | 'buy';
  logo?: boolean;
  whiteLogo?: boolean;
}

const labelMap: Record<Props['variant'], string> = {
  living: 'common.branding.living',
  search: 'common.branding.search',
  rent: 'common.branding.search',
  buy: 'common.branding.search',
};

const suffixMap: Partial<Record<Props['variant'], string>> = {
  rent: 'common.branding.searchForRenting',
  buy: 'common.branding.searchForBuying',
};

export const PlusBadge: React.FC<Props> = ({ variant, logo = true, whiteLogo = false }) => {
  const { t } = useIntl();

  const label = t({ id: labelMap[variant] });
  const suffixId = suffixMap[variant];
  const suffix = suffixId ? t({ id: suffixId }) : null;

  const textClass = css(whiteLogo && styles.white);

  return (
    <>
      {logo ? (
        <span className={textClass}>
          <Indicator className={textClass} appearance='plus' asSpan>
            <span className={css(styles.logo)}>{label}</span>
          </Indicator>
        </span>
      ) : (
        <span>{label}+</span>
      )}
      {suffix && <>&nbsp;{suffix}</>}
    </>
  );
};
